import React, { Component } from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import FullProductDevelopmentCycle from 'views/fullProductDevelopmentCycle';
import Layout from 'components/layout';
import { NavBar, PopupRedirect } from 'components';
import { pages } from 'config/pages';
import config from '../../meta/config';

class FPDCPage extends Component {
  render() {
    const page = pages['full-cycle-product-development'];
    const { navColors } = page;
    const canonical = `${config.siteUrl}/full-cycle-product-development/`;

    const { data } = this.props;
    const { allArticles } = data || {};

    return (
      <Layout {...{page, canonical}}>
        <Helmet title="Full Cycle Product Development">
          <meta
            name={'description'}
            content={
              'Boldare will guide you through full cycle product development: from a simple prototype, MVP through the product-market fit and to the scalable app growth.'
            }
          />
          <link rel="canonical" href={canonical} />
        </Helmet>
        <NavBar color={navColors} />
        <PopupRedirect />
        <FullProductDevelopmentCycle allArticles={allArticles} />
      </Layout>
    );
  }
}

export const pageQuery = graphql`
  query FPDCQuery {
    allArticles: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___settings___date] }
      filter: {
        frontmatter: {
          title: {
            in: [
              "Visualising Energy"
              "How to scale a monolithic MVP application without losing business?"
              "From design to development in 4 weeks. Creating a mobile and web MVP for an iconic brand"
              "Designing a simple search experience for a complex product with a luxurious interface"
              "How to deliver an e-commerce platform MVP in just 6 weeks"
            ]
          }
        }
      }
    ) {
      ...markdownFields
      ...boxMarkdownFields
    }
  }
`;

export default FPDCPage;
